import Swiper, { Navigation, EffectFade, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

Swiper.use([Navigation, EffectFade, Autoplay]);

const homeCarousel = () => {
  var hs = new Swiper('.hero-swiper', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    speed: 1000,
    navigation: {
      nextEl: ".hero-button-next",
      prevEl: ".hero-button-prev",
    },
  });
};

export default homeCarousel;